<header class="header" [class.initial]="!isScrolled " [class.floating]="isScrolled" >
  <div class="header-content">
    <div class="header-inner">

      <button class="btn btn-primary menu-button" (click)="toggleNav()">
        <svg *ngIf="!isNavActive" width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
        <svg *ngIf="isNavActive" width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
      <!-- Logo -->
      <div class="logo">
        <!-- <div class="logo-icon"></div> -->
        <!-- <span class="logo-text">HealthBoost</span> -->
        <img src="./facewithlogo.svg" alt="DR.Piyu Logo" class="logo-image" >
      </div>

      <!-- Social Media Icons -->
      <!-- <div class="social-icons">
        <a href="https://facebook.com" target="_blank" class="social-icon" title="Facebook">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </a>
        <a href="https://instagram.com" target="_blank" class="social-icon" title="Instagram">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.790-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
        <a href="https://wa.me/1234567890" target="_blank" class="social-icon" title="WhatsApp">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.886 3.488"/>
          </svg>
        </a>
        <a href="tel:+1234567890" class="social-icon" title="Phone">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </a>
      </div> -->

      <!-- Desktop Navigation -->
      <nav class="nav-desktop">
        <div class="nav-links">
          <a 
            routerLink="/home" 
            class="nav-link"
            routerLinkActive="active">
            {{ t('home') }}
          </a>
          <a 
            routerLink="/about" 
            class="nav-link"
            routerLinkActive="active">
            {{ t('about') }}
          </a>
          <a 
            routerLink="/contact" 
            class="nav-link"
            routerLinkActive="active">
            {{ t('contact') }}
          </a>
        </div>
      </nav>

      <!-- Right side actions -->
      <div class="actions">
        
        <!-- Language Selector - Hidden on mobile -->
        <div class="desktop-language-selector">
          <app-language-selector></app-language-selector>
        </div>
        
        <!-- User menu: keep icon, switch dropdown contents by auth state -->
        <div class="user-menu">
          <button class="action-btn">
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
          </button>
          <div class="dropdown-menu">
            <ng-container *ngIf="isLoggedIn(); else showLoginOnly">
              <!-- User Info Section -->
              <div class="user-info-dropdown">
                <div class="user-name-dropdown">
                  <i class="fas fa-user"></i>
                  <span>{{ currentUser?.name || 'User' }}</span>
                </div>
                <div class="user-mobile-dropdown">
                  <i class="fas fa-phone"></i>
                  <span>{{ currentUser?.mobile || 'No mobile' }}</span>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <button (click)="goToOrderHistory()">
                <i class="fas fa-history"></i>
                <span>{{ t('orderHistory') }}</span>
              </button>
              <button (click)="logout()">
                <i class="fas fa-sign-out-alt"></i>
                <span>{{ t('logout') }}</span>
              </button>
            </ng-container>
            <ng-template #showLoginOnly>
              <button (click)="navigateTo('/login')">{{ t('login') }}</button>
            </ng-template>
          </div>
        </div>
        <!-- Cart -->
        <button class="action-btn" (click)="toggleCart()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m9.5-5l-2.5 5"></path>
          </svg>
          <span *ngIf="cartCount > 0" class="cart-badge">
            {{cartCount}}
          </span>
        </button>

      </div>
    </div>

  </div>
</header>

<!-- Mobile Navigation - Outside of header for independent positioning -->
<nav class="mobile-nav" [class.nav-active]="isNavActive">
  <!-- Mobile menu header with login/user info and close button -->
  <div class="mobile-menu-header">
    <!-- Login button for non-logged users -->
    <button *ngIf="!isLoggedIn()" class="login-btn" (click)="navigateTo('/login')">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
      </svg>
      {{ t('login') }}
    </button>
    
    <!-- User info for logged users -->
    <div *ngIf="isLoggedIn()" class="user-info">
      <div class="user-icon">
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
      </div>
      <div class="user-details">
        <div class="user-name">{{ currentUser?.name || 'User' }}</div>
        <div class="user-mobile">{{ currentUser?.mobile || 'No mobile' }}</div>
      </div>
    </div>
    
    <button class="close-menu-btn" (click)="toggleNav()">
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>
  
  <div class="nav-links">
    <a 
      routerLink="/home" 
      class="nav-link"
      routerLinkActive="active"
      (click)="closeMenu()">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
      </svg>
      {{ t('home') }}
    </a>
    <a 
      routerLink="/about" 
      class="nav-link"
      routerLinkActive="active"
      (click)="closeMenu()">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      {{ t('about') }}
    </a>
    <a 
      routerLink="/contact" 
      class="nav-link" 
      routerLinkActive="active"
      (click)="closeMenu()">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
      </svg>
      {{ t('contact') }}
    </a>
    
    <!-- Order History button for logged in users -->
    <a 
      *ngIf="isLoggedIn()"
      routerLink="/orders" 
      class="nav-link"
      routerLinkActive="active"
      (click)="closeMenu()">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
      </svg>
      {{ t('orderHistory') }}
    </a>
    
    <!-- Language Selector for Mobile -->
    <app-mobile-language-selector></app-mobile-language-selector>
  </div>
  
  <!-- Logout button at bottom for mobile menu -->
  <div class="mobile-menu-footer" *ngIf="isLoggedIn()">
    <button class="logout-btn" (click)="logout()">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
      </svg>
      {{ t('logout') }}
    </button>
  </div>
</nav>
